// extracted by mini-css-extract-plugin
module.exports = {"title":"confirm-email_title__1cIsX","link":"confirm-email_link__sJIjr","textWrap":"confirm-email_textWrap__1ckjm"};